import React, { useEffect } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import style from "./style";
import { IconSuccess } from "../../../../Icons";
import _ from "lodash";
import classNames from "classnames";

const useStyles = makeStyles((theme: Theme) => createStyles(style(theme)));

type props = {
  onFbResponse: any;
  scope: any;
  fields: any;
  appid: any;
  AuthGroup: any
};

export const FacebookAuth = (props: props): JSX.Element => {
  const classes = useStyles();
  const { onFbResponse, fields, scope, appid, AuthGroup } = props;
  const visibllity = (!_.isEmpty(AuthGroup.value) && !_.isNull(AuthGroup.value)) ? "visible" : "hidden";

  useEffect(() => {
      const channel = new BroadcastChannel("meta-auth-channel");
      channel.onmessage = (event) => {
        const accessToken: any = event.data.accessToken;
        onFbResponse({ accessToken: accessToken ,fields:fields});
      };
      return () => channel.close();
    }, []);

  const handleFacebookLogin = (): void => {
    const state = encodeURIComponent(`${window.origin}/meta`);
    const appId = appid; // Replace with your Facebook App ID
    const redirectUri = `${process.env.REACT_APP_SOCIAL_CALLBACK}/metacallback`; // Must match your app settings
    const scopes = scope; // Permissions you need
    const width = 599;
    const height = 599;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;
    const features = `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`;
    const facebookAuthUrl = `${process.env.REACT_APP_FB_LOGIN_URL}?client_id=${appId}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${scopes}&state=${state}&response_type=token`;
    window.open(facebookAuthUrl, "childwindow", features);
  };

  return (
    <div className={classes.facebookContainer}>
      <button onClick={handleFacebookLogin}
        disabled={!_.isEmpty(AuthGroup.value) && !_.isNull(AuthGroup.value)}
        className={classNames(classes.button, "MuiButtonBase-root")}>
        <svg className={classes.facebookIcon} focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z"></path></svg>
        Login with Facebook
      </button>
      <div className={classes.SuccessIconDiv} style={{ visibility: visibllity }}>
        <IconSuccess />
      </div>
    </div>
  );
};
